export default __webpack_public_path__ + "static/media/default.9f7aeaca2fd7bd9eacb0afc0d46f4d5e.png";